import React from 'react';
import { DynamicTypography } from './styled';
import { TypographyProps } from './types';

export const Typography: React.FC<TypographyProps> = ({
  tag,
  variant,
  $lineToShow,
  children,
  ...props
}) => (
  <DynamicTypography {...{ tag, variant, $lineToShow, ...props }}>
    {children}
  </DynamicTypography>
);
